var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 130,
    viewBox: "0 0 138 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0906 0.225012H86.775L44.5406 125.361C44.1065 126.647 43.2801 127.764 42.1777 128.556C41.0753 129.347 39.7525 129.773 38.3953 129.773H6.73281C5.70454 129.774 4.69102 129.529 3.7761 129.06C2.86117 128.59 2.07114 127.91 1.47137 127.075C0.871589 126.239 0.479304 125.273 0.326964 124.256C0.174625 123.239 0.266611 122.201 0.59531 121.227L39.9437 4.63751C40.3776 3.35111 41.2042 2.23325 42.3069 1.44137C43.4096 0.649501 44.733 0.223525 46.0906 0.22345V0.225012Z",
    fill: "url(#paint0_linear_101_483)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.211 84.1578H40.6953C40.0955 84.1572 39.5094 84.3372 39.0134 84.6744C38.5173 85.0115 38.1343 85.4903 37.9143 86.0483C37.6942 86.6063 37.6473 87.2176 37.7796 87.8026C37.912 88.3876 38.2174 88.9192 38.6562 89.3281L80.1125 128.022C81.3195 129.148 82.9087 129.774 84.5594 129.773H121.091L105.211 84.1578Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0907 0.225023C44.7182 0.219756 43.3801 0.653456 42.2717 1.46277C41.1632 2.27209 40.3426 3.41461 39.9297 4.72346L0.643774 121.12C0.292961 122.098 0.182824 123.146 0.32268 124.176C0.462537 125.205 0.848272 126.186 1.44726 127.034C2.04624 127.883 2.84085 128.575 3.76386 129.052C4.68688 129.529 5.71115 129.776 6.75002 129.773H39.2297C40.4394 129.557 41.57 129.024 42.5061 128.228C43.4422 127.432 44.1502 126.401 44.5578 125.242L52.3922 102.153L80.3766 128.255C81.5493 129.225 83.0204 129.761 84.5422 129.773H120.938L104.975 84.1578L58.4422 84.1688L86.9219 0.225023H46.0907Z",
    fill: "url(#paint1_linear_101_483)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0546 4.63123C97.6214 3.3469 96.796 2.23089 95.695 1.44041C94.5939 0.649925 93.2726 0.224818 91.9171 0.224976H46.575C47.9303 0.225053 49.2516 0.650251 50.3526 1.4407C51.4536 2.23115 52.279 3.34703 52.7125 4.63123L92.0625 121.225C92.3914 122.199 92.4836 123.238 92.3314 124.255C92.1792 125.273 91.787 126.239 91.1872 127.075C90.5874 127.91 89.7973 128.591 88.8823 129.06C87.9672 129.53 86.9535 129.775 85.925 129.775H131.269C132.297 129.775 133.311 129.53 134.225 129.06C135.14 128.59 135.93 127.909 136.53 127.074C137.129 126.238 137.522 125.272 137.674 124.255C137.826 123.238 137.734 122.199 137.405 121.225L98.0546 4.63123Z",
    fill: "url(#paint2_linear_101_483)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_483",
    x1: 60.9187,
    y1: 9.82501,
    x2: 18.6672,
    y2: 134.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_483",
    x1: 74.1172,
    y1: 67.9953,
    x2: 64.3438,
    y2: 71.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_483",
    x1: 68.7421,
    y1: 6.18435,
    x2: 115.122,
    y2: 129.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLogo);
export default __webpack_public_path__ + "static/media/azure-logo.57ab4c53a9346715c8defd40cd65498e.svg";
export { ForwardRef as ReactComponent };